import { getAnalytics, isSupported, logEvent } from 'firebase/analytics';
import app from './firebaseApp';

let analyticsInstance = null;
let analyticsInitPromise = null;

export async function initAnalytics() {
  if (analyticsInitPromise) return analyticsInitPromise;

  analyticsInitPromise = (async () => {
    try {
      const supported = await isSupported();
      if (!supported) return null;
      analyticsInstance = getAnalytics(app);
      return analyticsInstance;
    } catch (error) {
      console.warn('Analytics unavailable:', error);
      return null;
    }
  })();

  return analyticsInitPromise;
}

export async function trackPageView(path) {
  const analytics = analyticsInstance || (await initAnalytics());
  if (!analytics || !path) return;

  logEvent(analytics, 'page_view', {
    page_path: path,
    page_location: `${window.location.origin}${path}`,
    page_title: document.title,
  });
}